module.exports = __webpack_public_path__ + "img/posterBanner.f7419558.png";